import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductPage from "./pages/ProductPage";
import ContactPage from "./pages/ContactPage";
import CertifiedDiamondsPage from "./pages/CertifiedDiamondsPage";
import MeleeDiamondsPage from "./pages/MeleeDiamondsPage";
import FancyCutDiamondsPage from "./pages/FancyCutDiamondsPage";
import FancyColorDiamondsPage from "./pages/FancyColorDiamondsPage";
import MatchingPairDiamondsPage from "./pages/MatchingPairDiamondsPage";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL || ""}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/certified-diamonds" element={<CertifiedDiamondsPage />} />
          <Route path="/melee-diamonds" element={<MeleeDiamondsPage />} />
          <Route path="/fancy-cut-diamonds" element={<FancyCutDiamondsPage />} />
          <Route path="/fancy-color-diamonds" element={<FancyColorDiamondsPage />} />
          <Route path="/matching-pair-diamonds" element={<MatchingPairDiamondsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
